import { postRequest } from './request';

export interface CreateInviteDto {
  email: string;
  orgName?: string;
  role?: string;
}

export const resendInvite = (dto: CreateInviteDto) => postRequest(`/invites/resend`, dto);
